var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"blog-paginator__item"},[_c('a',{class:_vm.active,on:{"click":function($event){return _vm.SendFilter($event.target, _vm.pag)}}},[_vm._v(_vm._s(_vm.pag))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c24ef3d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/blog/andromeda/components/paginatorItem.vue
// module id = 82
// module chunks = 0